export const name = 'comboboxinputNavigation' as const
